"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./RadioText.css");
var accessibility_1 = require("../../../../../utils/accessibility");
var RadioText = /** @class */ (function (_super) {
    __extends(RadioText, _super);
    function RadioText(props) {
        var _this = _super.call(this, props) || this;
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        return _this;
    }
    RadioText.prototype.handleKeyPress = function (e) {
        if ((this.props.data.disabled === undefined || this.props.data.disabled === false) &&
            (e.key === 'Enter' || e.charCode === 13)) {
            this.props.events.onKeyPress(this.props.data.value);
        }
    };
    RadioText.prototype.render = function () {
        var labelClasses = this.props.data.disabled ?
            [styles.radioTextItem, styles.disabled].join(' ') :
            styles.radioTextItem;
        return (React.createElement("label", __assign({ "data-test-id": this.props.testId, className: labelClasses, onKeyPress: this.handleKeyPress }, (this.props.options) ? accessibility_1.getAccessibilityAttributes(this.props.options) : {}),
            this.renderAccessibilityElement(),
            React.createElement("input", __assign({ className: styles.radioTextInput, type: "radio", name: this.props.name, checked: this.props.selected, onChange: this.props.events.onChange }, this.props.data)),
            this.renderText()));
    };
    RadioText.prototype.renderAccessibilityElement = function () {
        /* istanbul ignore next */
        if (this.props.options && this.props.options.accessibility) {
            return (React.createElement("div", __assign({ className: styles.hiddenSpoken, dangerouslySetInnerHTML: { __html: this.props.options.accessibility } }, (this.props.options && this.props.options.arialabelledby)
                ? { id: this.props.options.arialabelledby } : {})));
        }
    };
    RadioText.prototype.renderText = function () {
        var text = this.props.children ? this.props.children : this.props.data.value;
        return (React.createElement("span", __assign({ className: styles.radioTextItemText }, (this.props.options && this.props.options.arialabelledby) ? { 'aria-hidden': true } : {}), text));
    };
    return RadioText;
}(React.Component));
exports.default = RadioText;
//# sourceMappingURL=RadioText.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/RadioGroup/components/RadioText/RadioText.js
// module id = 1232
// module chunks = 8